import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IListSubmarketsData,
  ISearchCbsaData,
  ISearchCbsaInput,
} from '@shared/models/account-preferences';

export const LIST_SUBMARKETS: TypedDocumentNode<IListSubmarketsData> = gql`
  query listSubmarkets {
    listSubmarkets {
      id
      name
      displayName
    }
  }
`;

export const SEARCH_CBSA: TypedDocumentNode<
  ISearchCbsaData,
  ISearchCbsaInput
> = gql`
  query searchCbsa($text: String!) {
    searchCbsa(text: $text) {
      preference
      type
    }
  }
`;
